<template>
	<tr>
		<td class="px-6 py-4 whitespace-no-wrap w-128">
			<div class="flex items-center">
				<div class="mr-4 w-8 flex justify-center">
					<font-awesome-icon :icon="['fas', 'building']" size="2x" />
				</div>

				<div class="ml-4 text-left">
					<div class="text-md leading-5 font-medium text-gray-900 font-bold">{{ getCompanyName }}</div>
					<div class="text-md leading-5 text-gray-500">{{ getOwnerName }}</div>
				</div>
			</div>
		</td>

		<td class="px-6 py-4 text-left whitespace-no-wrap">
			<div class="text-md leading-5 text-gray-900">{{ getOwnerName }}</div>
			<div class="text-md leading-5 text-gray-500">{{ company.email }}</div>
			<div class="text-md leading-5 text-gray-500">{{ getPhoneNumber }}</div>
		</td>

		<td class="px-6 py-4 text-left whitespace-no-wrap">
			<div class="text-md leading-5 text-gray-900">{{ getAddress }}</div>
			<div class="text-md leading-5 text-gray-500">{{ getCityWithZipCode }}</div>
		</td>
	</tr>
</template>
<script>
import { concatArray, getStringFromDate, getTimeFromDate } from '@/plugins/Utils';
import { AuthenticationApiFactory, CustomerconsultantsApiFactory, UserApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'ChildCompanyRow',
	mixins: [Authentication],
	props: {
		company: {},
	},
	data() {
		return {
			page: 1,
		};
	},
	methods: {
		redirectToTarget($event, url, params) {
			//	this.$router.push({ name: 'OtherUserprofile', params: { id: this.employee.id.toString() } });
		},
	},
	computed: {
		getOwnerName() {
			return concatArray([this.company.ownerFirstname, this.company.ownerLastname]);
		},
		getOwnerEmail() {
			return concatArray([this.company.email, this.company.ownerLastname]);
		},
		getPhoneNumber() {
			return concatArray(['Tel: ', this.company.phoneNumber]);
		},
		getCompanyName() {
			return this.company.name;
		},
		getAddress() {
			if (this.company.poBox != null) {
				return this.$t('po_box') + ' ' + this.company.poBox;
			}
			return concatArray([this.company.street, this.company.houseNumber]);
		},
		getCityWithZipCode() {
			return concatArray([this.company.city.name, this.company.city.zipCode]);
		},
	},
};
</script>
